import posthog from 'posthog-js';
import { publicPosthogKey, publicPosthogHost } from '../../../constants/config';

// Only initialize once, at app startup
posthog.init(publicPosthogKey, {
  api_host: publicPosthogHost,
});

// Track a custom event
export function TrackPostHogEvent(eventName, properties = {}) {
  if (posthog) {
    posthog.capture(eventName, properties);
  }
}

// Identify a user
export function IdentifyPostHogUser(userId, properties = {}) {
  if (posthog) {
    posthog.identify(userId, properties);
  }
}